module.exports = __webpack_public_path__ + "static/media/service-scenario-bg.60fc35bc.png";